import { api } from "@/lib/orgApi";

export async function searchAllergens({
  q,
  allergenType,
  active = true,
  limit = 25,
} = {}) {
  const params = {};
  if (q) params.q = q;
  if (allergenType) params.allergenType = allergenType;
  if (active != null) params.active = active;
  if (limit != null) params.limit = limit;
  const { data } = await api.get("/allergens", { params });
  return data;
}

export async function getAllergen(id) {
  const { data } = await api.get(`/allergens/${encodeURIComponent(id)}`);
  return data;
}
